<template>
  <modal :active="active" @close="handleCloseModal">
    <div v-if="actionType == 'createModal'" slot="title">
      Create New Project
    </div>
    <div v-else slot="title">Update Project</div>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import ProjectStorer from "../../../../storers/StoreProject";
import { mapState } from "vuex";
export default {
  data() {
    return {
      name: null,
      description: null,
      start_date: null,
      end_date: null,
      maturity: null,
      cluster_id: null,
      asset_id: null,
      region_id: null,
      country_id: null,
      status: null,
      project_activity: null,
      currency_id: null,
      principal_native: null,
      principal_usd: null,
      allocation_ratio: null,
      debt: null,
      outstanding_native: null,
      outstanding_usd: null,
      performance: null,
      healthiness_factor: null,
      diversification_factor: null,
      impactfulness_factor: null,
    };
  },
  props: {
    active: Boolean,
    actionType: String,
    activeProject: Object,
  },
  components: { Spinner, Modal },
  created: function () {},
  computed: {
    ...mapState({}),
  },
  methods: {
    init() {
      this.name = null;
      this.description = null;
      this.start_date = null;
      this.end_date = null;
      this.maturity = null;
      this.cluster_id = null;
      this.asset_id = null;
      this.region_id = null;
      this.country_id = null;
      this.status = null;
      this.project_activity = null;
      this.currency_id = null;
      this.principal_native = null;
      this.principal_usd = null;
      this.allocation_ratio = null;
      this.debt = null;
      this.outstanding_native = null;
      this.outstanding_usd = null;
      this.performance = null;
      this.healthiness_factor = null;
      this.diversification_factor = null;
      this.impactfulness_factor = null;
    },
    fillForm() {
      this.name = this.activeProject.name;
      this.description = this.activeProject.description;
      this.start_date = this.activeProject.start_date;
      this.end_date = this.activeProject.end_date;
      this.maturity = this.activeProject.maturity;
      this.cluster_id = this.activeProject.cluster_id;
      this.asset_id = this.activeProject.asset_id;
      this.region_id = this.activeProject.region_id;
      this.country_id = this.activeProject.country_id;
      this.status = this.activeProject.status;
      this.project_activity = this.activeProject.project_activity;
      this.currency_id = this.activeProject.currency_id;
      this.principal_native = this.activeProject.principal_native;
      this.principal_usd = this.activeProject.principal_usd;
      this.allocation_ratio = this.activeProject.allocation_ratio;
      this.debt = this.activeProject.debt;
      this.outstanding_native = this.activeProject.outstanding_native;
      this.outstanding_usd = this.activeProject.outstanding_usd;
      this.performance = this.activeProject.performance;
      this.healthiness_factor = this.activeProject.healthiness_factor;
      this.diversification_factor = this.activeProject.diversification_factor;
      this.impactfulness_factor = this.activeProject.impactfulness_factor;
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    handleSave() {
      var project = ProjectStorer();
      if (this.actionType == "updateModal") {
        project.id = this.activeProject.id;
      }
      project.name = this.name;
      project.description = this.description;
      project.start_date = this.start_date;
      project.end_date = this.end_date;
      project.maturity = this.maturity;
      project.cluster_id = this.cluster_id;
      project.asset_id = this.asset_id;
      project.region_id = this.region_id;
      project.country_id = this.country_id;
      project.status = this.status;
      project.project_activity = this.project_activity;
      project.currency_id = this.currency_id;
      project.principal_native = this.principal_native;
      project.principal_usd = this.principal_usd;
      project.allocation_ratio = this.allocation_ratio;
      project.debt = this.debt;
      project.outstanding_native = this.outstanding_native;
      project.outstanding_usd = this.outstanding_usd;
      project.performance = this.performance;
      project.healthiness_factor = this.healthiness_factor;
      project.diversification_factor = this.diversification_factor;
      project.impactfulness_factor = this.impactfulness_factor;
      this.$emit("saveRequest", project);
    },
  },
  watch: {
    actionType() {
      this.init();
      if (this.actionType == "updateModal") {
        this.fillForm();
      }
    },
  },
};
</script> 
 <style>
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/projectModal.vue